// components/modals/invitations/user/project-access-inline.jsx
import { Select } from "antd";
import UserActivityStatus from "../../../../components/user-activity-status/user-activity-status";
import { RowSites } from "./project-access-table";
import { roleOptionsFor, rowRoleOf } from "./role-options";

const RoleChip = ({ row }) => (
  <UserActivityStatus
    userStatus={row.roleKey}
    text={row.roleName}
    fontSize={14}
    style={{ whiteSpace: "nowrap" }}
  />
);

const ProjectAccessInline = ({
  row,                        // { key, projectId, roleId, roleName, roleSiteScoping, roleKey, siteIds }
  sitesFor,                   // (projectId) => { sitesEnabled, options }
  roles = [],                 // the roles the signed-in user may give
  projectRoleDropdownKey,
  setProjectRoleDropdownKey,
  updateRow,                  // (key, patch) => void
  isEdit = true,
  canEdit = true,
}) => {
  if (!row) return null;

  const { sitesEnabled } = sitesFor(row.projectId);
  const editable = isEdit && canEdit;

  return (
    <div className="invite-user__projects">

      {/* PROJECT ROLE — first, as in the organization table */}
      <div className="invite-user__field invite-user__field__role">
        <p className="invite-user__field__role-name invite-user__field__name">Project role</p>

        {editable ? (
          <div className="invite-user__project-role-wrapper">
            <button
              type="button"
              className="invite-user__role-trigger"
              onClick={() => setProjectRoleDropdownKey(row.key)}
            >
              {row.roleId ? (
                <RoleChip row={row} />
              ) : (
                <span className="invite-user__role-placeholder">
                  Select role
                </span>
              )}

              <span className="invite-user__role-arrow" />
            </button>

            <Select
              className="invite-user__project-role-select"
              variant="borderless"
              value={row.roleId}
              open={projectRoleDropdownKey === row.key}
              onOpenChange={(open) => {
                setProjectRoleDropdownKey(open ? row.key : null);
              }}
              onChange={(val) => {
                updateRow(row.key, rowRoleOf(roles.find((role) => role.id === val)));
                setProjectRoleDropdownKey(null);
              }}
              options={roleOptionsFor(roles, row)}
              popupMatchSelectWidth={false}
            />
          </div>
        ) : row.roleId ? (
          <RoleChip row={row} />
        ) : <div>—</div> }
      </div>

      {/* SITES */}
      {sitesEnabled && (
        <div className="invite-user__field invite-user__field__sites">
          <p className="invite-user__field__role-name invite-user__field__name">Sites</p>
          <RowSites
            row={row}
            sitesFor={sitesFor}
            updateRow={updateRow}
            readOnly={!editable}
          />
        </div>
      )}
    </div>
  );
};

export default ProjectAccessInline;
